import styled from 'styled-components';

export const StyledLicenseAgreementContent = styled.div`
  .license-agreement-content__subheading,
  .license-agreement-content__paragraph {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-bottom: 1em;
    column-gap: 1em;
  }

  .license-agreement-content__heading {
    ${(props): string => props.theme.fontStyles.heading3};
    margin-bottom: 1em;
  }

  .license-agreement-content__subheading {
    ${(props): string => props.theme.fontStyles.heading4};
  }

  .license-agreement-content__paragraph {
    ${(props): string => props.theme.fontStyles.p1.news};
  }

  .license-agreement-content__spacer {
    width: 26px;
  }

  .license-agreement-content__text {
    flex-basis: auto;
  }
`;
